// import React from "react";
// import { FaShieldAlt, FaUserTie, FaCar } from "react-icons/fa";

// const FeatureStyleOne = () => {
//   return (
//     <section className="feature-style-one thm-black-bg">

//       {/* Background Image */}
//       <img
//         src="images/background/feature-bg-1-1.png"
//         alt="Background"
//         className="feature-bg"
//       />

//       <div className="container">

//         {/* Section Title */}
//         <div className="block-title text-center">
//           <div className="dot-line"></div>
//           <p>Om Sai Cab Service Benefits</p>
//           <h2 className="light">Why choose us</h2>
//         </div>

//         <div className="row">

//           {/* Feature 1 */}
//           <div className="col-lg-4 col-md-6">
//             <div className="single-feature-one text-center">

//               <div className="icon-block">
//                 <FaShieldAlt size={45} color="#ffffff" />
//               </div>

//               <h3 className="text-white">Safety Guarantee</h3>

//               <p>
//                 We ensure safe and secure rides with verified drivers and
//                 well-maintained vehicles for your comfort.
//               </p>
//             </div>
//           </div>

//           {/* Feature 2 */}
//           <div className="col-lg-4 col-md-6">
//             <div className="single-feature-one text-center">

//               <div className="icon-block">
//                 <FaUserTie size={45} color="#ffffff" />
//               </div>

//               <h3 className="text-white">Professional Drivers</h3>

//               <p>
//                 Experienced and polite drivers providing smooth and stress-free travel experience.
//               </p>
//             </div>
//           </div>

//           {/* Feature 3 */}
//           <div className="col-lg-4 col-md-6">
//             <div className="single-feature-one text-center">

//               <div className="icon-block">
//                 <FaCar size={45} color="#ffffff" />
//               </div>

//               <h3 className="text-white">Easy Booking</h3>

//               <p>
//                 Quick and simple booking process for local and outstation cab services anytime.
//               </p>
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeatureStyleOne;








import React from "react";
import {
  FaShieldAlt,
  FaUserTie,
  FaCar,
  FaClock,
  FaMapMarkedAlt,
  FaMoneyBillWave
} from "react-icons/fa";

const FeatureStyleOne = () => {
  return (
    <section className="feature-style-one thm-black-bg">
      {/* Background Image */}
      <img
        src="images/background/feature-bg-1-1.png"
        alt="Background"
        className="feature-bg"
      />

      <div className="container">
        {/* Section Title */}
        <div className="block-title text-center">
          <div className="dot-line"></div>
          <p>Om Sai Cab Service Benefits</p>
          <h2 className="light">Why Choose Us</h2>
        </div>

        <div className="row">
          {/* Feature 1 */}
          <div className="col-lg-4 col-md-6">
            <div className="single-feature-one text-center">
              <div className="icon-block">
                <FaShieldAlt size={45} color="#ffffff" />
              </div>

              <h3 className="text-white">Safety Guarantee</h3>

              <p>
                We ensure safe and secure rides with verified drivers and
                well-maintained vehicles for your comfort.
              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="col-lg-4 col-md-6">
            <div className="single-feature-one text-center">
              <div className="icon-block">
                <FaUserTie size={45} color="#ffffff" />
              </div>

              <h3 className="text-white">Professional Drivers</h3>

              <p>
                Experienced and courteous drivers providing a smooth,
                comfortable, and stress-free travel experience.
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="col-lg-4 col-md-6">
            <div className="single-feature-one text-center">
              <div className="icon-block">
                <FaCar size={45} color="#ffffff" />
              </div>

              <h3 className="text-white">Easy Booking</h3>

              <p>
                Quick and hassle-free booking process for local, airport,
                and outstation cab services anytime.
              </p>
            </div>
          </div>

          {/* Feature 4 */}
          <div className="col-lg-4 col-md-6">
            <div className="single-feature-one text-center">
              <div className="icon-block">
                <FaClock size={45} color="#ffffff" />
              </div>

              <h3 className="text-white">24/7 Availability</h3>

              <p>
                Our cab services are available round the clock to meet your
                travel needs anytime, anywhere.
              </p>
            </div>
          </div>

          {/* Feature 5 */}
          <div className="col-lg-4 col-md-6">
            <div className="single-feature-one text-center">
              <div className="icon-block">
                <FaMapMarkedAlt size={45} color="#ffffff" />
              </div>

              <h3 className="text-white">Local & Outstation Trips</h3>

              <p>
                We provide reliable transportation for city rides, airport
                transfers, sightseeing tours, and long-distance journeys.
              </p>
            </div>
          </div>

          {/* Feature 6 */}
          <div className="col-lg-4 col-md-6">
            <div className="single-feature-one text-center">
              <div className="icon-block">
                <FaMoneyBillWave size={45} color="#ffffff" />
              </div>

              <h3 className="text-white">Affordable Pricing</h3>

              <p>
                Transparent pricing with no hidden charges, ensuring the best
                value and complete peace of mind for every trip.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureStyleOne;

